// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("./ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function UpgradePlanWarningV5$Warning(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "bg-yellow-50 border border-gray-200 text-center text-yellow-800 p-4 leading-5 rounded-md"
  });
}

let Warning = {
  make: UpgradePlanWarningV5$Warning
};

function UpgradePlanWarningV5(props) {
  return JsxRuntime.jsx(UpgradePlanWarningV5$Warning, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: props.children
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.Link.make, {
            href: "/subscribe",
            children: "Upgrade to Pro"
          })
        })
      ],
      className: "flex flex-col gap-4"
    })
  });
}

let make = UpgradePlanWarningV5;

exports.Warning = Warning;
exports.make = make;
/* ButtonsV5 Not a pure module */
